import React, { Component, Fragment } from 'react';

import { DocumentFieldText } from 'components/cards/document/preview/DocumentFieldText';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import FieldsGroup from 'components/cards/document/fields/FieldsGroup';
import { getValue, xmlArrayToObj, checkGroup, getPhoneString, getComputerSkills } from 'helpers/documentsHelpers';
import DocumentTable from '../preview/DocumentTable';
import { competenceColumns, educationColumns, employmentPlacesColumns } from 'constants/xmlTableColumns';

class LandingResponse extends Component {
    header = checkGroup(({ firstName, lastName, middleName, sex, citizenship, createdate, birthDate, birthPlace }) => (
        <FieldsGroup translate="form" translatePrefix='PplAnketa'>
            <DefinitionField translate="xml.PplAnketa.createdate">
                <DocumentFieldText
                    name="xml.PplAnketa.createdate"
                    value={createdate}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.full-name">
                <DocumentFieldText
                    name="xml.PplAnketa.full-name"
                    value={lastName + ' ' + firstName + ' ' + middleName || ''}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.sex" show={!!sex}>
                <DocumentFieldText
                    name="xml.PplAnketa.sex"
                    value={sex}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.birth-date" show={!!birthDate}>
                <DocumentFieldText
                    name="xml.PplAnketa.birth-date"
                    value={birthDate}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.citizenship" show={!!citizenship}>
                <DocumentFieldText
                    name="xml.PplAnketa.citizenship"
                    value={citizenship}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.birthPlace" show={!!birthPlace}>
                <DocumentFieldText
                    name="xml.PplAnketa.birthPlace"
                    value={birthPlace}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    residenceAddress = checkGroup(({ city }) => (
        <FieldsGroup translate="residenceAddress"  translatePrefix='PplAnketa'>
                <DocumentFieldText
                    name="xml.PplAnketa.city"
                    value={city}
                />
        </FieldsGroup>
    ))

    phones = checkGroup(({ contactPhone, contactPhoneCode, mobilePhone, mobilePhoneCode }) => (
        <FieldsGroup translate="phones" translatePrefix='PplAnketa'>
            <DefinitionField translate={contactPhoneCode ? "xml.PplAnketa.home-phone" : "xml.PplAnketa.contact-phone"} show={!!contactPhone}>
                <DocumentFieldText
                    name="xml.PplAnketa.contact-phone"
                    value={getPhoneString(contactPhoneCode, contactPhone)}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.mob-phone" show={!!mobilePhone}>
                <DocumentFieldText
                    name="xml.PplAnketa.mob-phone"
                    value={getPhoneString(mobilePhoneCode, mobilePhone)}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    contacts = checkGroup(({ email }) => (
        <FieldsGroup translate="contacts"  translatePrefix='PplAnketa'>
            <DefinitionField translate="xml.PplAnketa.email" show={!!email}>
                <DocumentFieldText
                    name="xml.PplAnketa.email"
                    value={email}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    landingData = checkGroup(({ rusLangLevel,
        engLangLevel,
        military,
        maritalStatus,
        children,
        badHabits,
        conviction,
        pcLevel,
        personalСar,
        usePersonalСar,
        specTech,
        workPermissions,
        medicalBook,
        intPassport,
        timeSheet,
        workType,
        timeToWork,
        readyToMove,
        businesstrip,
        workExperience,
        feedback,
        desiredPosition,
        computerSkills,
    }) => (
        <FieldsGroup translate="landingData"  translatePrefix='PplAnketa'>
            <DefinitionField translate="xml.PplAnketa.rus-lang-level" show={!!rusLangLevel}>
                <DocumentFieldText
                    name="xml.PplAnketa.rus-lang-level"
                    value={rusLangLevel}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.eng-lang-level" show={!!engLangLevel}>
                <DocumentFieldText
                    name="xml.PplAnketa.eng-lang-level"
                    value={engLangLevel}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.military" show={!!military}>
                <DocumentFieldText
                    name="xml.PplAnketa.military"
                    value={military}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.family-status" show={!!maritalStatus}>
                <DocumentFieldText
                    name="xml.PplAnketa.family-status"
                    value={maritalStatus}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.children" show={!!children}>
                <DocumentFieldText
                    name="xml.PplAnketa.children"
                    value={children}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.bad-habits" show={!!badHabits}>
                <DocumentFieldText
                    name="xml.PplAnketa.bad-habits"
                    value={badHabits}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.conviction" show={!!conviction}>
                <DocumentFieldText
                    name="xml.PplAnketa.conviction"
                    value={conviction}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.pc-level" show={!!pcLevel}>
                <DocumentFieldText
                    name="xml.PplAnketa.pc-level"
                    value={pcLevel}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.personal-car" show={!!personalСar}>
                <DocumentFieldText
                    name="xml.PplAnketa.personal-car"
                    value={personalСar}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.use-personal-car" show={!!usePersonalСar}>
                <DocumentFieldText
                    name="xml.PplAnketa.use-personal-car"
                    value={usePersonalСar}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.spec-tech" show={!!specTech}>
                <DocumentFieldText
                    name="xml.PplAnketa.spec-tech"
                    value={specTech}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.work-permissions" show={!!workPermissions}>
                <DocumentFieldText
                    name="xml.PplAnketa.work-permissions"
                    value={workPermissions}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.medical-book" show={!!medicalBook}>
                <DocumentFieldText
                    name="xml.PplAnketa.medical-book"
                    value={medicalBook}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.int-passport" show={!!intPassport}>
                <DocumentFieldText
                    name="xml.PplAnketa.int-passport"
                    value={intPassport}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.time-sheet" show={!!timeSheet}>
                <DocumentFieldText
                    name="xml.PplAnketa.time-sheet"
                    value={timeSheet}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.work-type" show={!!workType}>
                <DocumentFieldText
                    name="xml.PplAnketa.work-type"
                    value={workType}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.time-to-work" show={!!timeToWork}>
                <DocumentFieldText
                    name="xml.PplAnketa.time-to-work"
                    value={timeToWork}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.ready-to-move" show={!!readyToMove}>
                <DocumentFieldText
                    name="xml.PplAnketa.ready-to-move"
                    value={readyToMove}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.businesstrip" show={!!businesstrip}>
                <DocumentFieldText
                    name="xml.PplAnketa.businesstrip"
                    value={businesstrip}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.work-experience" show={!!workExperience}>
                <DocumentFieldText
                    name="xml.PplAnketa.work-experience"
                    value={workExperience}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.feedback" show={!!feedback}>
                <DocumentFieldText
                    name="xml.PplAnketa.feedback"
                    value={feedback}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.desired-position" show={!!desiredPosition}>
                <DocumentFieldText
                    name="xml.PplAnketa.desired-position"
                    value={desiredPosition}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.computerSkills" show={!!computerSkills}>
                <DocumentFieldText
                    name="xml.PplAnketa.computerSkills"
                    value={ getComputerSkills(computerSkills)}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    work = checkGroup(({ beginDate, endDate, organization, position, workFunction }) => (
        <FieldsGroup translate="workExperience"  translatePrefix='PplAnketa'>
            <DefinitionField translate="xml.PplAnketa.begin-date" show={!!beginDate}>
                <DocumentFieldText
                    name="xml.PplAnketa.begin-date"
                    value={beginDate}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.end-date" show={!!endDate}>
                <DocumentFieldText
                    name="xml.PplAnketa.end-date"
                    value={endDate}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.organization" show={!!organization}>
                <DocumentFieldText
                    name="xml.PplAnketa.organization"
                    value={organization}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.position" show={!!position}>
                <DocumentFieldText
                    name="xml.PplAnketa.position"
                    value={position}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.workFunction" show={!!workFunction}>
                <DocumentFieldText
                    name="xml.PplAnketa.workFunction"
                    value={workFunction}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    competence = checkGroup(({ competence }) => (
        <FieldsGroup translate="competence"  translatePrefix='PplAnketa'>
            <DocumentTable rows={competence} columns={competenceColumns} />
        </FieldsGroup>
    ))

    education = checkGroup(({ education }) => (
        <FieldsGroup translate="nissanEducation"  translatePrefix='PplAnketa'>
            <DocumentTable rows={education} columns={educationColumns} />
        </FieldsGroup>
    ))

    employmentPlaces = checkGroup(({ employmentPlaces }) => (
        <FieldsGroup translate="workExperience"  translatePrefix='PplAnketa'>
            <DocumentTable rows={employmentPlaces} columns={employmentPlacesColumns} />
        </FieldsGroup>
    ))

    head = checkGroup(({ headFullname, headPosition, headPhone, headEmail }) => (
        <FieldsGroup translate="head"  translatePrefix='PplAnketa'>
            <DefinitionField translate="xml.PplAnketa.NISSAN_HEAD_FULLNAME" show={!!headFullname}>
                <DocumentFieldText
                    name="xml.PplAnketa.NISSAN_HEAD_FULLNAME"
                    value={headFullname}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.NISSAN_HEAD_POSITION" show={!!headPosition}>
                <DocumentFieldText
                    name="xml.PplAnketa.NISSAN_HEAD_POSITION"
                    value={headPosition}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.NISSAN_HEAD_PHONE" show={!!headPhone}>
                <DocumentFieldText
                    name="xml.PplAnketa.NISSAN_HEAD_PHONE"
                    value={headPhone}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplAnketa.NISSAN_HEAD_EMAIL" show={!!headEmail}>
                <DocumentFieldText
                    name="xml.PplAnketa.NISSAN_HEAD_EMAIL"
                    value={headEmail}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    render() {
        const { xml } = this.props;
        const xmlObject = xmlArrayToObj(xml);

        return (
            <Fragment>
                {this.header({
                    firstName: getValue(xmlObject.fname),
                    lastName: getValue(xmlObject.lname),
                    middleName: getValue(xmlObject.sname),
                    sex: getValue(xmlObject.sex),
                    citizenship: getValue(xmlObject.citizenship),
                    createdate: getValue(xmlObject.createdate),
                    birthDate: getValue(xmlObject['birth-date']),
                    birthPlace: getValue(xmlObject.BIRHPLACE),
                })}
                {this.residenceAddress({
                    city: getValue(xmlObject.city),
                })}
                {this.phones({
                    contactPhone: getValue(xmlObject['contact-phone']),
                    contactPhoneCode: getValue(xmlObject.contacttelcode),
                    mobilePhone: getValue(xmlObject['mob-phone']),
                    mobilePhoneCode: getValue(xmlObject['mobcode']),
                })}
                {this.contacts({
                    email: getValue(xmlObject.email),
                })}
                {this.work({
                    beginDate: getValue(xmlObject['begin-date']),
                    endDate: getValue(xmlObject['end-date']),
                    organization: getValue(xmlObject.organization),
                    position: getValue(xmlObject.position),
                    workFunction: getValue(xmlObject.function),
                })}
                {this.education({
                    education: getValue(xmlObject.ppleducation),
                })}
                {this.employmentPlaces({
                    employmentPlaces: getValue(xmlObject['employment-places']),
                })}
                {this.landingData({
                    rusLangLevel: getValue(xmlObject.RUS_LANG_LEVEL_STR),
                    engLangLevel: getValue(xmlObject.FLUENTENGLISH_STR || xmlObject.NISSAN_ENGLISH_LEVEL_STR),
                    computerSkills: getValue(xmlObject.NISSAN_COMPUTER_SKILLS),
                    military: getValue(xmlObject.MILITARY_STR),
                    maritalStatus: getValue(xmlObject.MARITAL_STATUS_STR),
                    children: getValue(xmlObject.CHILDREN_STR),
                    badHabits: getValue(xmlObject.BAD_HABITS_STR),
                    conviction: getValue(xmlObject.CONVICTION_STR),
                    pcLevel: getValue(xmlObject.PC_PROFICIENCY_STR),
                    personalСar: getValue(xmlObject.HAS_AVTO_STR),
                    usePersonalСar: getValue(xmlObject.WOULD_USE_AVTO_STR),
                    specTech: getValue(xmlObject.DRIVE_SPEC_TECH_STR),
                    workPermissions: getValue(xmlObject.PERMISSIONS_TO_WORK),
                    medicalBook: getValue(xmlObject.HAS_MED_BOOK_STR),
                    intPassport: getValue(xmlObject.INTERNATIONAL_PASS_STR),
                    timeSheet: getValue(xmlObject.WORK_TIMESHEET_STR),
                    workType: getValue(xmlObject.WORK_TYPE_STR),
                    timeToWork: getValue(xmlObject.TIME_TO_GET_TO_WORK_STR),
                    readyToMove: getValue(xmlObject.READY_TO_MOVE_STR),
                    businesstrip: getValue(xmlObject.BUSINESSTRIP_STR),
                    workExperience: getValue(xmlObject.WORK_EXPERIENCE_STR),
                    feedback: getValue(xmlObject.CALLBACK_TYPE_STR),
                    desiredPosition: getValue(xmlObject.DESIRED_POSITION_STR),
                })}
                {this.head({
                    headFullname: getValue(xmlObject.NISSAN_HEAD_FULLNAME),
                    headPosition: getValue(xmlObject.NISSAN_HEAD_POSITION),
                    headPhone: getValue(xmlObject.NISSAN_HEAD_PHONE),
                    headEmail: getValue(xmlObject.NISSAN_HEAD_EMAIL),
                })}
                {this.competence({
                    competence: getValue(xmlObject.NISSAN_COMPETENCIES),
                })}
            </Fragment>
        );
    }
}

export default LandingResponse;
